/**
 * Light sync watermark / delta page — plan/33.
 * lastUpdated = last row on this page (not MAX of whole table).
 */
/** (updatedAt, id) > (since, sinceId) */
export function rowAfterWatermark(row, since) {
    if (!since?.lastUpdated)
        return true;
    if (row.updatedAt > since.lastUpdated)
        return true;
    if (row.updatedAt < since.lastUpdated)
        return false;
    if (!since.lastId)
        return true;
    return row.id > since.lastId;
}
export function filterDeltaRows(rows, since) {
    if (!since?.lastUpdated)
        return [...rows];
    return rows.filter((r) => rowAfterWatermark(r, since));
}
/** Paged watermark = last row on this page */
export function watermarkFromPage(rows) {
    const last = rows[rows.length - 1];
    if (!last)
        return { lastUpdated: null, lastId: null };
    return { lastUpdated: last.updatedAt, lastId: last.id };
}
export function mergeById(existing, delta) {
    const map = new Map(existing.map((r) => [r.id, r]));
    for (const row of delta)
        map.set(row.id, row);
    return [...map.values()];
}
/** Drop soft-deleted from active cache after merge */
export function activeOnly(rows) {
    return rows.filter((r) => !r.deleted);
}
